import React from "react";
import DataTable from "react-data-table-component";
import '../../../global.css'

const AlternativePagination = ({ columns, data }) => {
  return <DataTable columns={columns} data={data} pagination />;
};

export { AlternativePagination };
